import * as React from 'react';
import { Translate } from '../../../shared/LanguageService';
import IBrokerListAgent from './IBrokerListAgent';
import { Table } from 'react-bootstrap';
import BrokerAgentListRow from './BrokerAgentListRow';

interface IBrokerListAgentProps {
    items: IBrokerListAgent[];
    edit: (agent: IBrokerListAgent) => void;
    delete: (id: number) => void;
    restore: (id: number) => void;
    currentUserId: number;
}

const BrokerListAgents = (props: IBrokerListAgentProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('brokers/list/table-header/name')}</th>
                    <th>{Translate('brokers/list/table-header/head-office')}</th>
                    <th>{Translate('brokers/list/table-header/removed')}</th>
                </tr>
            </thead>
            <tbody>
                {props.items &&
                    props.items.map((item: IBrokerListAgent) => {
                        return (
                            <BrokerAgentListRow
                                BrokerListAgent={item}
                                key={item.id}
                                edit={props.edit}
                                delete={props.delete}
                                restore={props.restore}
                                currentUserId={props.currentUserId}
                            />
                        );
                    })}
            </tbody>
        </Table>
    );
};

export default BrokerListAgents;
